import Enum from './enum'

class SignatureState extends Enum
{
  constructor(value) {
    super(value);
  }
}

SignatureState.init({
  PROCESSING: 'Processing',
  APPROVED: 'Approved',
  DECLINED: 'Declined',
  NOT_ACTIVE: 'NotActive'
}, {
  PROCESSING: 'accreditation-state.processing',
  APPROVED: 'accreditation-state.approved',
  DECLINED: 'accreditation-state.declined',
  NOT_ACTIVE: 'accreditation-state.not-active'
});

export default SignatureState;
